import { PropertyListEffects } from './property-list/property-list.effects';
export const effects = [PropertyListEffects];

export * from './reducers';
